import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(trackReservation),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(doCancelReservation),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(doReserveClass),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(watchCancelReservation),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(watchRequestReservation);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { fetchEntity, fetchEntityIfNeeded } from '@classpass/saga-tools';
import { ec } from 'helpers/multitrack';
import { cancelReservation, createReservation, similarVenues, userActionCampaignEvent, userProfile } from 'redux/saga/entities/bound';
import { getUserId } from 'redux/saga/helpers';
import { readSessionStorage } from 'redux/saga/helpers/local-storage';
var CANCEL_RESERVATION = 'Reservation/CANCEL_RESERVATION';
var REQUEST_RESERVATION = 'Reservation/REQUEST_RESERVATION';
var RESERVATION_STATUS_CHANGED = 'Reservation/RESERVATION_STATUS_CHANGED';
export var requestCancelReservation = function requestCancelReservation(reservationId) {
  return {
    type: CANCEL_RESERVATION,
    reservationId: reservationId
  };
};
export var requestReservation = function requestReservation(scheduleId, venueId, reservationParams, trackingParams) {
  return {
    type: REQUEST_RESERVATION,
    scheduleId: scheduleId,
    venueId: venueId,
    reservationParams: reservationParams,
    trackingParams: trackingParams
  };
};
export var reservationStatusChanged = function reservationStatusChanged() {
  return {
    type: RESERVATION_STATUS_CHANGED
  };
};
export function trackReservation(scheduleId) {
  var reservationId,
      params,
      trackingParams,
      _args = arguments;
  return regeneratorRuntime.wrap(function trackReservation$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          reservationId = _args.length > 1 && _args[1] !== undefined ? _args[1] : 0;
          params = _args.length > 2 ? _args[2] : undefined;
          _context.t0 = _objectSpread;
          _context.t1 = {
            url: window.location.pathname,
            schedule_id: scheduleId,
            reservation_id: reservationId,
            failed: false,
            top_up: false,
            top_up_price: null,
            top_up_credit_amount: null
          };
          _context.next = 6;
          return call(readSessionStorage, "schedule_".concat(scheduleId), {});

        case 6:
          _context.t2 = _context.sent;
          _context.t3 = params;
          trackingParams = (0, _context.t0)(_context.t1, _context.t2, _context.t3);
          _context.next = 11;
          return call(ec, 'Reserve Class', trackingParams);

        case 11:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function doCancelReservation(client, _ref) {
  var reservationId, userId;
  return regeneratorRuntime.wrap(function doCancelReservation$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          reservationId = _ref.reservationId;
          _context2.next = 3;
          return call(getUserId);

        case 3:
          userId = _context2.sent;
          _context2.next = 6;
          return call(fetchEntity, cancelReservation, [client, userId, reservationId, {
            state: 'cancel'
          }]);

        case 6:
          _context2.next = 8;
          return put(reservationStatusChanged());

        case 8:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function doReserveClass(client, _ref2) {
  var scheduleId, venueId, _ref2$reservationPara, reservationParams, _ref2$trackingParams, trackingParams, user, params, reservation;

  return regeneratorRuntime.wrap(function doReserveClass$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          scheduleId = _ref2.scheduleId, venueId = _ref2.venueId, _ref2$reservationPara = _ref2.reservationParams, reservationParams = _ref2$reservationPara === void 0 ? {} : _ref2$reservationPara, _ref2$trackingParams = _ref2.trackingParams, trackingParams = _ref2$trackingParams === void 0 ? {} : _ref2$trackingParams;
          _context3.prev = 1;
          _context3.next = 4;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 4:
          user = _context3.sent;
          params = _objectSpread({
            schedule: scheduleId
          }, reservationParams);
          _context3.next = 8;
          return call(fetchEntity, createReservation, [client, user.id, params]);

        case 8:
          reservation = _context3.sent;
          _context3.next = 11;
          return all([put(reservationStatusChanged()), call(trackReservation, scheduleId, reservation.id, trackingParams), call(fetchEntityIfNeeded, similarVenues, [client, venueId]), call(fetchEntity, userActionCampaignEvent, [client, 'ReservationSuccess', {
            id: reservation.id,
            ignore_cooldown: true
          }])]);

        case 11:
          _context3.next = 17;
          break;

        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 17;
          return call(trackReservation, scheduleId, undefined, _objectSpread({}, trackingParams, {
            failed: true
          }));

        case 17:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 13]]);
}
export function watchCancelReservation(client) {
  return regeneratorRuntime.wrap(function watchCancelReservation$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return fork(takeEvery, CANCEL_RESERVATION, doCancelReservation, client);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
export function watchRequestReservation(client) {
  return regeneratorRuntime.wrap(function watchRequestReservation$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return fork(takeEvery, REQUEST_RESERVATION, doReserveClass, client);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}